module.exports = __webpack_public_path__ + "static/media/ss.1ba14435.svg";